// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton_button__1KoLb","icon":"IconButton_icon__AL1WC","label":"IconButton_label__13bFc"};